<div class="tanya p-5">
<div class="container">
    <div class="row text-center m-5">
        <div class="col-md-12">
            <h3>Get In Touch</h3>
            <p>Our team at East Indonesia Trips is committed to ensure you have a great and hassle-free experience with us always. Any questions.</p>
        </div>
    </div>
    <form [formGroup]="pertanyaanForm" (ngSubmit)="onSubmit()">
        <div class="row">

            <div class="col-md-6">
                <div class="mb-4">
                    <label for="nama_pelanggan" class="form-label">Full Name</label>
                    <input type="text" class="form-control" id="nama_pelanggan" formControlName="nama_pelanggan" placeholder="Full Name">
                </div>
            </div>

            <div class="col-md-6">
                <div class="mb-4">
                    <label for="email_pelanggan" class="form-label">Email <span class="penting">*</span></label>
                    <input type="email" class="form-control" id="email_pelanggan" formControlName="email_pelanggan" placeholder="Email address">
                    <div *ngIf="submitted && pertanyaanForm.controls['email_pelanggan'].invalid" class="text-danger">
                      Email is required
                    </div>
                  </div>
            </div>

            <div class="col-md-6">
                <div class="mb-4">
                    <label for="whatsapp_number" class="form-label">WhatsApp <span class="penting">*</span></label>
                    <input type="tel" class="form-control" id="whatsapp_number" formControlName="whatsapp_number" #phoneInput>
                    <div *ngIf="submitted && pertanyaanForm.controls['whatsapp_number'].invalid" class="text-danger">
                      WhatsApp is required
                    </div>
                  </div>
            </div>

            <div class="col-md-6">
                <div class="mb-4">
                    <label for="negara" class="form-label">Country <span class="penting">*</span></label>
                    <select id="negara" class="form-control" formControlName="negara">
                      <option value="" disabled selected>Select Country</option>
                      <option *ngFor="let item of data" [value]="item.nama_negara">{{ item.nama_negara }}</option>
                    </select>
                    <div *ngIf="submitted && pertanyaanForm.controls['negara'].invalid" class="text-danger">
                      Country is required
                    </div>
                  </div>
            </div>

            <div class="col-md-6">
                <div class="mb-4">
                    <label for="trip_kategori" class="form-label">Trip Category <span class="penting">*</span></label>
                    <select id="trip_kategori" class="form-select" formControlName="trip_kategori">
                      <option value="" disabled selected>-Select-</option>
                      <option value="Boat Charter">Boat Charter</option>
                      <option value="Open Trip Komodo National Park">Open Trip Komodo National Park</option>
                      <option value="Open Trip Raja Ampat">Open Trip Raja Ampat</option>
                    </select>
                    <div *ngIf="submitted && pertanyaanForm.controls['trip_kategori'].invalid" class="text-danger">
                      Trip Category is required
                    </div>
                  </div>
            </div>

            <div class="col-md-6">
                <div class="mb-4">
                    <label for="destinasi" class="form-label">Destinations <span class="penting">*</span></label>
                    <select id="destinasi" class="form-select" formControlName="destinasi">
                      <option value="" disabled selected>-Select-</option>
                      <option value="Alor Island">Alor Island</option>
                      <option value="Banda Island">Banda Island</option>
                      <option value="Komodo National Park">Komodo National Park</option>
                      <option value="Raja Ampat">Raja Ampat</option>
                    </select>
                    <div *ngIf="submitted && pertanyaanForm.controls['destinasi'].invalid" class="text-danger">
                      Destinations is required
                    </div>
                  </div>
            </div>
            
            <div class="col-md-6">
                <div class="form-group mb-4">
                    <label for="start_date">Start Date <span class="penting">*</span></label>
                    <input type="text" class="form-control" id="start_date" formControlName="start_date" (change)="onDateChange('start_date', $event)">
                    <div *ngIf="submitted && pertanyaanForm.controls['start_date'].invalid" class="text-danger">
                      Start Date is required
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group mb-4">
                    <label for="end_date">End Date <span class="penting">*</span></label>
                    <input type="text" class="form-control" id="end_date" formControlName="end_date" (change)="onDateChange('end_date', $event)">
                    <div *ngIf="submitted && pertanyaanForm.controls['end_date'].invalid" class="text-danger">
                      End Date is required
                    </div>
                  </div>
            </div>
    
      
          <div class="col-md-12">
            <div class="form-group mb-4">
              <label for="inquiry">Your Inquiry</label>
              <textarea class="form-control" id="inquiry" rows="3" formControlName="inquiry"></textarea>
            </div>
          </div>
      
         <div class="col-md-12">
            <div class="d-grid gap-2">
              <button type="submit" class="boxed-btn4 mb-4" [disabled]="loading">
                <span *ngIf="!loading">Submit Form</span>
                <span *ngIf="loading">
                  <i class="fa fa-spinner fa-spin"></i> Submitting...
                </span>
              </button>
            </div>
          </div>

        </div>
   </form>

<!-- Pesan Konfirmasi -->
<div *ngIf="formSubmitted" class="alert alert-secondary" role="alert">
    Thank you for your message. We will get in touch with you shortly.
</div>
   


</div>
</div>
